import React, { PropsWithChildren } from 'react';
import originalStyles from '../../styles/asial-website-footer.module.scss';
import { extractStyle } from '../../styles/styles-extract-util';
import cn from 'classnames';

export const AsialWebsiteFooterBaseGrid: React.FC<PropsWithChildren> = ({ children }) => {
  const styles = extractStyle(originalStyles);
  return <div className={cn(styles['base-grid'], 'base-grid')}>{children}</div>;
};
